import React, { useState, memo, useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import clsx from 'clsx';
import {
  Grid,
  Typography,
  makeStyles,
  Chip,
  Paper,
  TextField,
  Badge,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useParams } from 'react-router-dom';

import { BadgeButton } from '../../constants';

import './scss/mui.scss';
import { updateSidebarAction } from '../../actions/repairOrder/ro-actions';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    flexWrap: 'wrap',
    listStyle: 'none',
    padding: theme.spacing(0.5),
    margin: 0,
    boxShadow: 'none',
    background: 'transparent',
  },
  label: {
    fontSize: '13px',
    color: '#263238',
    lineHeight: '17px',
    fontWeight: '500',
  },
  labelCus: {
    color: '#545B7D',
    fontSize: '13px',
    fontWeight: 'normal',
    lineHeight: '16px',
  },
  chip: {
    background: '#F0E9F9',
    borderRadius: '100px',
    color: '#6921C4',
    fontSize: '13px',
    lineHeight: '16px',
    fontWeight: 'bold',
    marginRight: '10px',
  },
  chipClose: {
    background: '#E7ECF4',
    color: '#6D7D8B',
    fontWeight: 'bold',
    marginLeft: '10px',
    cursor: 'pointer',
  },
  badge__gutter: {
    marginBottom: '0.5rem',
    [theme.breakpoints.down('xs')]: {
      marginLeft: '0',
    },
  },
  tags__btn: {
    transform: 'rotate(45deg)',
    // marginLeft: '10px',
    cursor: 'pointer',
  },
  customBadge: {
    color: 'white',
    cursor: 'pointer',
    position: 'absolute',
    right: '12px',
  },
  cursor__pointer: {
    cursor: 'pointer',
  },
  tags__add__remove: {
    padding: '5px',
    marginLeft: '0.6rem',
    backgroundColor: '#E7ECF4 !important',
    marginBottom: '0.5rem',
    '& svg': {
      fontSize: '18px',
    },
  },
  padding__none: {
    marginLeft: '0',
  },
}));

const Tags = ({ usedIn, tagsToUpdate, tags = [], isViewOnly = false }) => {
  const classes = useStyles();

  const [addTag, setAddTag] = useState(false);
  const [chipData, setChipData] = useState([]);
  const [chipValue, setChipValue] = useState([]);

  useEffect(() => {
    if (usedIn === 'ro_edit_customer') {
      if (tags?.length) {
        tags = tags?.filter((t) => t?.trim());

        setChipData(tags);
      }
    }
  }, [tags]);
  const { id } = useParams();

  const dispatch = useDispatch();
  const handleChangeInput = (ev) => {
    let { value } = ev.target;
    value = value ? value.trim() : '';
    if (ev.key === 'Enter') {
      if (!value || chipData.some((chip) => chip === value)) return;
      setChipData([...chipData, value]);
      const data = [...chipData, value];

      if (usedIn === 'ro_edit_customer') {
        tagsToUpdate(data);
      } else if (usedIn === 'roSideBar') {
        dispatch(
          updateSidebarAction({
            id,
            tags:
              chipData?.length > 0 ? chipData.join(',') + ',' + value : value,
          }),
        );
      }
      ev.preventDefault();

      setChipValue('');
    }
  };
  const { ro } = useSelector((reduxState) => reduxState.ro.roData);

  useEffect(() => {
    if (usedIn === 'roSideBar' && ro?.tags?.length > 0) {
      setChipData(ro?.tags?.toString()?.split(','));
    }
  }, [ro?.tags]);

  const removeTag = (ind) => {
    const filteredTags = chipData.filter((chip, i) => i !== ind);
    setChipData(filteredTags?.length > 0 ? filteredTags : []);

    if (usedIn === 'ro_edit_customer') {
      tagsToUpdate(filteredTags?.length > 0 ? filteredTags : []);
    } else if (usedIn === 'roSideBar') {
      dispatch(
        updateSidebarAction({
          id,
          tags: filteredTags?.join(','),
        }),
      );
    }
  };
  return (
    <>
      <Grid container>
        <Grid item xs={12}>
          <Typography
            display='block'
            gutterBottom
            className={
              usedIn === 'ro_edit_customer' ? classes.labelCus : classes.label
            }
          >
            Tags:
          </Typography>
          <Paper component='ul' className={classes.root}>
            {chipData?.map((data, ind) => {
              return (
                data !== '' && (
                  <Badge
                    badgeContent={
                      !isViewOnly && (
                        <BadgeButton
                          onClick={() => {
                            removeTag(ind);
                          }}
                        />
                      )
                    }
                    classes={{ badge: classes.customBadge }}
                    className={classes.badge__gutter}
                  >
                    <li key={data}>
                      <Chip label={data} className={classes.chip} />
                    </li>
                  </Badge>
                )
              );
            })}
            {chipData?.length < 3 && !isViewOnly && (
              <>
                {addTag ? (
                  <>
                    <TextField
                      id='id'
                      name='name'
                      onChange={(e) =>
                        e.target.value.length <= 20 &&
                        setChipValue(e.target.value)
                      }
                      className='form_field_jobcard_tags'
                      placeholder='Enter Tag'
                      type='text'
                      value={chipValue}
                      onKeyPress={(ev) => {
                        handleChangeInput(ev);
                      }}
                    />
                    <IconButton
                      className={classes.tags__add__remove}
                      onClick={() => setAddTag(false)}
                    >
                      <CloseIcon className={classes.cursor__pointer} />
                    </IconButton>
                  </>
                ) : (
                  <IconButton
                    className={clsx(
                      classes.padding__none,
                      classes.tags__add__remove,
                    )}
                    disabled={isViewOnly} // view case in customer listing
                    onClick={() => setAddTag(true)}
                  >
                    <CloseIcon className={classes.tags__btn} />
                  </IconButton>
                )}
              </>
            )}
          </Paper>
        </Grid>
      </Grid>
    </>
  );
};

export default memo(Tags);
